import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {SucursalDTO} from "../../dtos/sucursal.dto";
import {StorageService} from "./storage-service";

@Injectable({
  providedIn: 'root'
})
export class SucursalService {

  private sucursalesSubject: BehaviorSubject<Array<SucursalDTO>>;
  public sucursales$: Observable<Array<SucursalDTO>>;
  private todasSeleccionadas: boolean;

  constructor(private storageService: StorageService) {
    this.sucursalesSubject = new BehaviorSubject<Array<SucursalDTO>>(this.storageService.getSucursalesSeleccionadas());
    this.sucursales$ = this.sucursalesSubject.asObservable();
    this.todasSeleccionadas = this.storageService.getTodasSucursalesSeleccionadas();
  }

  getSucursalesSeleccionadas(): Array<SucursalDTO> {
    return this.sucursalesSubject.getValue();
  }

  setSucursalesSeleccionadas(sucursalesSeleccionadas: Array<SucursalDTO>, todasSeleccionadas: boolean = false) {
    this.storageService.setSucursalesSeleccionadas(sucursalesSeleccionadas);
    this.storageService.setTodasSucursalesSeleccionadas(todasSeleccionadas);
    this.todasSeleccionadas = todasSeleccionadas;
    this.sucursalesSubject.next(sucursalesSeleccionadas);
  }

  isTodasSeleccionadas(): boolean {
    return this.todasSeleccionadas;
  }

  getSucursalesUUIDSeleccionadasComoTexto(): string {
    return this.getSucursalesSeleccionadas().map(sucursal => sucursal.uuid).join(', ');
  }

  getSucursalesUUIDComoTexto(listaSucursales : SucursalDTO []): string {
    return listaSucursales.map(sucursal => sucursal.uuid).join(', ');
  }

  getSucursalesNombresSeleccionadasComoTexto(nombreLargo: boolean = false): string {
    const seleccionadas = this.getSucursalesSeleccionadas();
    if(nombreLargo){
      return seleccionadas.map(sucursal => sucursal.nombre).join(', ');
    }else{
      if(seleccionadas.length > 2 ){
        return ` ${seleccionadas.length} seleccionadas`;
      }
      return seleccionadas.map(sucursal => sucursal.nombreAbreviado).join(', ');
    }
  }


}
